<template>
  <div class="openBox">
    <div class="openBox-top">
      <div class="openBox-top-left">开源项目</div>

      <div class="openBox-top-right"></div>
    </div>

    <div class="openBox-content">
      <el-carousel
        :interval="10000"
        type="card"
        arrow="always"
        :autoplay="false"
      >
        <el-carousel-item v-for="(item, index) in openProjectData" :key="index">
          <div class="openBox-content-box">
            <div>
              <el-image
                class="imgComp"
                :src="`/img/openProject/${item.projectName}.png` | imgFormat"
                :preview-src-list="
                  [`/img/openProject/${item.projectName}.png`] | imgFormat
                "
              >
                <div slot="placeholder" class="image-slot">
                  <img
                    style="width: 100%"
                    src="https://pic.imgdb.cn/item/65abdd55871b83018af558ee.gif"
                    alt=""
                  />
                </div>

                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>

            <el-tooltip
              class="item"
              effect="dark"
              :content="`点击访问${item.projectName}线上地址`"
              placement="top"
            >
              <div
                class="openBox-content-box-content"
                @click="openProjectLink(item.projectLink)"
              >
                <span class="openBox-content-box-content-name">
                  {{ item.projectName }}
                </span>
                <span class="openBox-content-box-content-info">
                  {{ item.moreInfo }}
                </span>
              </div>
            </el-tooltip>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { openProject } from "@/api/apifoxInterface";

export default {
  name: "openBox",
  components: {},
  props: {},
  data() {
    return {
      openProjectData: [],
      helpOpenProjectData: require("@/lib/json/apifox/openProject.json"),
    };
  },
  methods: {
    getOpenProjectData() {
      openProject().then((res) => {
        if (res.data.code === 200) {
          this.openProjectData = res.data.data;
        } else if (res.data.code === 504) {
          this.openProjectData = this.helpOpenProjectData.data;
        }
      });
    },

    openProjectLink(link) {
      window.open(link, "_blank");
    },
  },
  created() {
    this.getOpenProjectData();
  },
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.openBox {
  padding: 20px;

  &-top {
    height: 50px;
    display: flex;
    justify-content: space-between;
    line-height: 50px;

    &-left {
      font-size: 20px;
      font-weight: bold;
    }

    &-right {
    }
  }

  &-content {
    height: 320px;

    &-box {
      height: 286px;
      position: relative;

      .imgComp {
        //height: 73%;
        width: 44%;
        position: absolute;
        left: 0;
        right: 0;
        top: 10px;
        margin: auto;
        object-fit: contain;
      }

      img:hover {
      }

      &-content {
        height: 27%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0px;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        &-name {
          font-size: 14px;
          font-weight: 600;
          margin: 16px 0 8px 0;
        }

        &-info {
          font-size: 12px;
          font-weight: 400;
        }
      }

      &-content:hover {
        color: rgb(255, 165, 198) !important;
      }
    }

    &-box:hover {
      transform: scale(1.2);
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-carousel--horizontal {
  width: 100%;
  height: 100%;
}

::v-deep .el-carousel__container {
  width: 100%;
  height: 290px;
}
</style>
